
interface IRouteAbsRow {
    routeAbstractRow: Record<string, any>;
}

export const PrepareIndentRouteWiseData = (props: IRouteAbsRow) => {
    const { routeAbstractRow } = props;
    
    return (
        <tr style={{ border: "1px solid #E5E4E2" }}>
            {Object.keys(routeAbstractRow).slice(1).map((key, index) => (
                <td key={index} className={index === 0  ? "text-start" : "text-end"}>
                    {typeof routeAbstractRow[key] === "number" ? routeAbstractRow[key].toFixed(2) : routeAbstractRow[key]}
                </td>
            ))}
        </tr>
    );
};
